////////LIBRARY/////////
import { find, isUndefined, map, forEach, isEmpty, isNull } from 'lodash'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import styled from 'styled-components'
///////COMPONENTS///////
import { HeaderCells, HeaderCellsSticky, TableHeaderWrapper } from '../../../../theme/GlobalCss'
import IsAction from '../IsAction'
import IsVisible from '../IsVisible'
import TableRows from '../TableRows'
import SortableImage from './SortableImage'
/////////ASSETS/////////
import nestedDropDownIcon from '../../../../assets/icones/table/nested-dropdown-all.svg'

/////////STYLED/////////
const ActionsHeaderCampaign = styled(HeaderCells)`
	width: 96px;
`
const CheckboxAllWrapper = styled(HeaderCells)`
	width: min-content;
`
const ToggleAllNestedWrapper = styled(HeaderCells)`
	width: min-content;
	& > img {
		display: block;
		cursor: pointer;
		transform: ${(props) => (props.dropped ? 'rotate(180deg)' : 'rotate(0deg)')};
	}
`
/////////STYLED/////////

const TableHeader = ({
	columns,
	sortTable,
	checkboxConf,
	editing,
	nestedTheme = false,
	data,
	setValue,
	hasNestedValues = false,
	setToggleAllNestedHandler,
	inLineEdit,
	isCampaignHeader,
	_resetCheckAll,
	toggleAllNestedHandler,
	setIsMassEdit,
	storedChecks,
}) => {
	const [checkAllFlag, setCheckAllFlag] = useState(false)
	const checkAll = map(data, (elem) => JSON.stringify(elem))
	const { translations, user } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			user: state.user,
		}),
		shallowEqual
	)
	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleCheckAll = () => {
		let values = []
		if (checkAllFlag) {
			checkAll.forEach((_elem, id) => {
				values.push({ id: false })
			})
			setValue(values)
			setIsMassEdit(false)
		} else {
			checkAll.forEach((elem, id) => {
				values.push({ id: elem })
			})
			setValue(values)
			setIsMassEdit(true)
		}
		setCheckAllFlag((prev) => !prev)
	}
	// we do a test for display double arrow only if we have nested datas
	let hasDataNested = false

	// We might need to back call every time we want to toggle all nested
	// Because if only one line has nested values, the back call can't be made for the rest of lines
	//let containsDataNested = false
	forEach(data, (elem) => {
		if (
			!isUndefined(elem[hasNestedValues.nestedData]) &&
			(typeof elem[hasNestedValues.nestedData] === 'string' || typeof elem[hasNestedValues.nestedData] === 'object')
		) {
			if (isNull(elem[hasNestedValues.nestedData])) {
				hasDataNested = true
			} else if (elem[hasNestedValues.nestedData].length > 0) {
				hasDataNested = true
				//containsDataNested = true
			}
		}
	})

	const handleToggleAll = () => {
		if (!isUndefined(hasNestedValues.nestedMassCall) && hasDataNested && !toggleAllNestedHandler /*&& !containsDataNested*/) {
			hasNestedValues.nestedMassCall()
			setToggleAllNestedHandler()
		} else {
			hasDataNested && setToggleAllNestedHandler()
		}
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (checkAllFlag) {
			checkAll.forEach((elem, id) => setValue(id.toString(), elem))
		} else {
			checkAll.forEach((id) => setValue(id.toString(), false))
		}
		if (!editing) {
			setCheckAllFlag(false)
			setIsMassEdit(false)
		}
	}, [editing])

	useEffect(() => {
		if (isEmpty(storedChecks)) {
			setCheckAllFlag(false)
			setIsMassEdit(false)
		}
	}, [storedChecks])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<TableHeaderWrapper>
			<TableRows>
				{checkboxConf && !editing && (
					<CheckboxAllWrapper>
						<input type="checkbox" checked={checkAllFlag} onChange={handleCheckAll} />
					</CheckboxAllWrapper>
				)}
				{hasNestedValues && !isUndefined(setToggleAllNestedHandler) && (
					<ToggleAllNestedWrapper onClick={() => handleToggleAll()} dropped={toggleAllNestedHandler}>
						<img src={hasDataNested ? nestedDropDownIcon : null} />
					</ToggleAllNestedWrapper>
				)}
				{map(columns, (column, id) => {
					let actionAuthorized = true
					const f = find(user.identity.rolePrivileges.privileges, (o) => o.label === column.checkRight) ? true : false
					if (!isUndefined(column.checkRight) && !f && column.action) {
						actionAuthorized = false
					}
					if (!isUndefined(column.boolRight) && !column.boolRight) {
						actionAuthorized = false
					}
					return actionAuthorized ? (
						<IsVisible key={id} isVisible={editing || inLineEdit ? true : column.visibility}>
							{/* Check if action column is mapped with a right, so we test it*/}
							<IsAction
								data={{ column: column, action: sortTable }}
								isAction={column.action || false}
								actionCell={() =>
									!isCampaignHeader ? (
										<HeaderCellsSticky hasActionIconsDisplay={column.hasActionIconsDisplay} nestedTheme={nestedTheme}>
											{translations['common__text__tab_actions']}
										</HeaderCellsSticky>
									) : (
										<ActionsHeaderCampaign nestedTheme={nestedTheme}>ACTIONS</ActionsHeaderCampaign>
									)
								}
								normalCell={(data) => (
									<>
										<HeaderCells
											nestedTheme={nestedTheme}
											onClick={() => data.action(data.column.sortableId, data.column.headerName)}
										>
											{data.column.headerName}
											{data.column.sortable && <SortableImage nestedTheme={nestedTheme} />}
										</HeaderCells>
									</>
								)}
							/>
						</IsVisible>
					) : null
				})}
			</TableRows>
		</TableHeaderWrapper>
	)
}

TableHeader.propTypes = {
	columns: PropTypes.array.isRequired,
}

TableHeader.defaultPropTypes = {
	columns: [],
}

export default TableHeader
